var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ug-tab-item",class:{
    'ug-tab-item__active': _vm.active,
    'ug-tab-item__disabled': _vm.disabled
  },on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }